<div class="qb-button" (click)="qbConnect()">
  <img ngSrc="QBButton.svg" priority alt="QuickBooks Button" class="imageBtn" [height]="height" [width]="width" />
  <img
    ngSrc="QBButtonHover.svg"
    priority
    alt="QuickBooks Button hover"
    class="imageBtnHover"
    [height]="height"
    [width]="width"
  />
</div>
